module.exports = __webpack_public_path__ + "static/media/headshot.be3149b7.jpg";